module.exports = __webpack_public_path__ + "img/apply_2@2x.6b067a61.png";